import { render, staticRenderFns } from "./SampleHandover.vue?vue&type=template&id=2e8b37c3&scoped=true"
import script from "./SampleHandover.vue?vue&type=script&lang=js"
export * from "./SampleHandover.vue?vue&type=script&lang=js"
import style0 from "./SampleHandover.vue?vue&type=style&index=0&id=2e8b37c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8b37c3",
  null
  
)

export default component.exports